/**
 * EventTypeModal.tsx
 *
 * "What type of event are you creating?" overlay.
 * Two large cards: Single Event vs External Event.
 */

import React from 'react';
import { FiX, FiCalendar, FiExternalLink } from 'react-icons/fi';
import { useNavigate } from '@tanstack/react-router';

export const EventTypeModal: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm px-4"
      onClick={() => window.history.back()}
    >
      <div
        className="w-full max-w-xl bg-zinc-950 border border-white/10 rounded-3xl p-6 sm:p-8 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-white text-lg sm:text-xl font-semibold">
            What type of event are you creating?
          </h2>
          <button
            onClick={() => window.history.back()}
            className="p-2 rounded-full hover:bg-white/5 transition-colors text-zinc-400 hover:text-white"
          >
            <FiX size={22} />
          </button>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Single Event */}
          <button
            onClick={() => navigate({ to: '/events/create/single', replace: true })}
            className="group flex flex-col items-center text-center p-6 sm:p-8 rounded-2xl bg-zinc-900 border border-white/5 hover:border-white/15 hover:bg-zinc-800/50 transition-all duration-200 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-full bg-zinc-800 border border-white/10 flex items-center justify-center mb-4 group-hover:bg-zinc-700 transition-colors">
              <FiCalendar size={24} className="text-white" />
            </div>
            <h3 className="text-white text-base font-semibold mb-1">Single Event</h3>
            <p className="text-zinc-500 text-sm leading-relaxed">
              Create and manage your event on Musicade
            </p>
          </button>

          {/* External Event */}
          <button
            onClick={() => navigate({ to: '/events/create/external', replace: true })}
            className="group flex flex-col items-center text-center p-6 sm:p-8 rounded-2xl bg-zinc-900 border border-white/5 hover:border-white/15 hover:bg-zinc-800/50 transition-all duration-200 cursor-pointer"
          >
            <div className="w-14 h-14 rounded-full bg-zinc-800 border border-white/10 flex items-center justify-center mb-4 group-hover:bg-zinc-700 transition-colors">
              <FiExternalLink size={24} className="text-white" />
            </div>
            <h3 className="text-white text-base font-semibold mb-1">External Event</h3>
            <p className="text-zinc-500 text-sm leading-relaxed">
              Link attendees to an external event or ticket page
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};
